/* eslint-disable max-len */
import React, {useState, useEffect} from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Button,
  Spinner
} from "reactstrap";
import LaddaButton, {EXPAND_RIGHT} from "react-ladda";
import PropTypes from "prop-types";

import {preCheckObjectEmpty} from "./ModalArchive";
import {
  FormField,
  SelectFormField,
  CustomFormInput,
  CheckFormField
} from "../../../utils/FormFields";
import Autosuggest from "../../AutosuggestCompliance";

const checkPhone = phone => phone.PhoneNumber;

const ModalPhone = ({
  open,
  onToggle,
  onSave,
  phoneTypes,
  initial,
  error,
  loading,
  messageShow,
  message,
  services
}) => {
  const [newPhone, setNewPhone] = useState({
    PhoneId: 0,
    PhoneType: "",
    PhoneNumber: ""
  });

  useEffect(() => {
    if (phoneTypes && !initial) {
      setNewPhone(d => ({
        ...d,
        PhoneType: phoneTypes[0].PhoneTypeDescription
      }));
    }
    if (initial) {
      setNewPhone(d => ({
        ...d,
        PhoneType: initial.PhoneType,
        PhoneNumber: initial.PhoneNumber,
        PhoneId: initial.PhoneId
      }));
    }
  }, [phoneTypes, initial]);

  const onChange = (name, value) => {
    const newNewPhone = {
      ...newPhone,
      [name]: value
    };
    if (name === "PhoneType") {
      phoneTypes.map(d => {
        if (d.PhoneType === value) {
          newNewPhone.PhoneType = d.PhoneType;
        }
        return {};
      });
    }
    setNewPhone({
      ...newNewPhone
    });
  };

  return (
    <div>
      <Modal isOpen={open} toggle={() => onToggle()}>
        <ModalHeader toggle={onToggle}>
          {initial === undefined ? "Append New " : "Edit "}
          Phone
        </ModalHeader>
        <ModalBody>
          {phoneTypes ? (
            <Form>
              <SelectFormField
                // disabled={initial !== undefined}
                label="Phone Type"
                value={newPhone.PhoneType}
                onChange={onChange}
                name="PhoneType"
                selectItems={phoneTypes}
                getSelectItemId={phoneTypes => phoneTypes.PhoneTypeDescription}
                getSelectItemName={phoneTypes =>
                  phoneTypes.PhoneTypeDescription
                }
              />
              <FormField
                label="Phone Number"
                value={newPhone.PhoneNumber}
                name="PhoneNumber"
                onChange={onChange}
                error={error}
              />
            </Form>
          ) : (
            <Spinner />
          )}
        </ModalBody>
        <ModalFooter>
          <LaddaButton
            className="btn btn-ladda btn-primary"
            loading={loading}
            disabled={!checkPhone(newPhone)}
            onClick={() => onSave(newPhone)}
            data-style={EXPAND_RIGHT}
          >
            {loading ? "Saving" : "Save"}
          </LaddaButton>{" "}
          <Button color="secondary" onClick={() => onToggle()}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

ModalPhone.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  phoneTypes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  initial: PropTypes.object,
  error: PropTypes.string,
  services: PropTypes.object.isRequired
};

ModalPhone.defaultProps = {
  initial: undefined,
  error: undefined
};

export default ModalPhone;
